import { ChangeDetectorRef, Component } from '@angular/core';
import { SelectHelpComponent } from '../select-help/select-help.component';
import { ActivatedRoute, Router } from '@angular/router';
import { EpApplicationService, EpDialogService, EpLocalStorageService, EpShellService, IEpSelectionListItem } from '@epicor/ux-platform';
import { SwaggerDocService } from '../services/swagger-doc.service';
import { HeaderService } from '../services/header.service';
import { HelpPageService } from '../services/help-page.service';
import { HelpType } from '../models/help-type';
import { RestVersions } from '../models/rest-versions';

@Component({
  selector: 'app-select-baq',
  templateUrl: '../select-help/select-help.component.html',
  styleUrls: ['../select-help/select-help.component.scss']
})
export class SelectBaqComponent extends SelectHelpComponent {
  baq: string;

  constructor(
    route: ActivatedRoute,
    router: Router,
    epApplicationService: EpApplicationService,
    swaggerDocService: SwaggerDocService,
    cdr: ChangeDetectorRef,
    epShellService: EpShellService,
    headerService: HeaderService,
    helpPageService: HelpPageService,
    epLocalStorageService: EpLocalStorageService
  ) {
    super(
      route,
      router,
      epApplicationService,
      swaggerDocService,
      cdr,
      epShellService,
      headerService,
      helpPageService,
      epLocalStorageService
    );
  }

  processRouteParams(params: any): void {
    const company = params['companyId'];
    if (company) {
      this.companyId = company;
    }
    const baq = params['baq'];
    if (baq) {
      this.baq = baq;
    }
    this.epShellService.setTitle(this.baq);
  }

  companyComboHidden(): boolean {
    return false;
  }

  isTabHidden(panelHelpType: HelpType): boolean {
    return panelHelpType !== HelpType.Baq;
  }

  onTabSelect(item): void {}

  searchMethod(item): void {
    this.currentSearch = item.event;
    this.searchForBaq(this.currentSearch);
  }

  selectHelpForType() {
    this.showBaq();
    this.tabModel.data[2].selected = true;
  }

  showBaq() {
    if (this.companyId && this.baq) {
      const url = this.getSwaggerDocLink();
      this.swaggerDocService.loadSwaggerDoc(url).subscribe({
        next: doc => {
          const currentSpec = this.updateCurrentSpec(doc);
          this.showSwaggerUI({ currentSpec: currentSpec });
        }
      });
    }
  }

  showHelpUI(item): void {
    const company = !this.companyId ? '' : this.companyId;
    this.router.navigate(['select-baq', this.version, company, item.event.text]);
  }

  versionComboHidden(): boolean {
    return false;
  }

  shouldShowSelectItemMessage(): boolean {
    return !(this.companyId && this.baq);
  }

  selectItemMessage(): string {
    return this.appStrings.useSearchBAQ;
  }

  searchForBaq(searchString: string) {
    this.helpPageService.getBaqs(this.companyId, searchString).subscribe({
      next: baqs => {
        this.panelListModel.items = baqs.map(baq => {
          return <IEpSelectionListItem>{
            id: baq.QueryID.toLowerCase(),
            text: baq.QueryID,
            description: baq.Description,
            selected: false
          };
        });
      },
      error: err => EpDialogService.error(err)
    });
  }

  changeCompany(item): void {
    this.searchForBaq(this.currentSearch);
  }

  changeVersion(item): void {} // baq list does not change on version

  getLegacyHelpPageLink() {
    const serverUrl = this.epApplicationService.sessionService.serverUrl;

    let helpUrl = serverUrl;

    if (this.version === RestVersions.V1) {
      helpUrl += `/api/help/v1/baq/${this.baq}(${this.companyId})/index`;
    } else {
      helpUrl += `/api/help/v2/baq/${this.companyId}/${this.baq}/index`;
    }
    return helpUrl;
  }

  getSwaggerDocLink(): string {
    const serverUrl = this.epApplicationService.sessionService.serverUrl;

    let swaggerFileUrl = serverUrl;

    if (this.version === RestVersions.V1) {
      swaggerFileUrl += `/api/swagger/v1/baq/${this.baq}(${this.companyId})`;
    } else {
      swaggerFileUrl += `/api/swagger/v2/baq/${this.companyId}/${this.baq}`;
    }
    return swaggerFileUrl;
  }

  shouldShowLinks(): boolean {
    return !!this.baq;
  }
}
